import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { SelectComponent } from '@agent-ds/shared/components/select/select.component';
import { GRAD_CATEGORY_OPTIONS } from '@agent-ds/shared/interfaces/job-az-check';
import { Component, ViewChild } from '@angular/core';
import { DialogConfig } from '../dialog/dialog-config';

export interface JobConditions {
  gradCategories?: string[];
  amount?: number;
  hours?: number;
  monthlyScheduledWorkingHours?: number;
  annualScheduledWorkingHours?: number;
  variableWorkingHoursSystem?: string;
}

export interface JobConditionAddDialogData {
  conditionKey: string;
  variableWorkingHoursSystemOptions?: string[];
  salaryTable?: any;
}

@Component({
  selector: 'ag-job-condition-add-dialog',
  templateUrl: './job-condition-add-dialog.component.html',
  styleUrls: ['./job-condition-add-dialog.component.scss'],
})
export class JobConditionAddDialogComponent {
  @ViewChild('gradCategorySelect', { static: false }) gradCategorySelect: SelectComponent;

  conditionKey: string;
  variableWorkingHoursSystemOptions: string[];
  salaryTable: { [key: string]: any };

  constructor(public dialog: DialogRef, public config: DialogConfig<JobConditionAddDialogData>) {
    const defaultData: JobConditionAddDialogData = { conditionKey: '' };
    const data = config.data || defaultData;
    this.conditionKey = data.conditionKey;
    this.variableWorkingHoursSystemOptions = data.variableWorkingHoursSystemOptions || [];
    this.salaryTable = data.salaryTable || {};
  }

  conditions: JobConditions = {};
  readonly gradCategoryOptions = GRAD_CATEGORY_OPTIONS;

  get title(): string {
    return this.conditionKey === 'other' ? 'その他の条件を追加する' : '種別を追加する';
  }

  get isAddDisabled(): boolean {
    switch (this.conditionKey) {
      case 'salary':
        return !this.hasAmount();
      case 'fixedOvertime':
      case 'fixedLateNightOvertime':
        return !this.hasFixedOvertimeConditions();
      case 'other':
        return !this.hasFixedOvertimeConditions() && !this.hasOtherConditions();
      default:
        return true;
    }
  }

  get hasFixedOvertimeFee(): boolean {
    return this.salaryTable.fixedOvertimeFee === '有';
  }

  close(conditions?: JobConditions) {
    this.dialog.close(conditions);
  }

  onVariableWorkingHoursSystemChange(value: string): void {
    this.conditions.variableWorkingHoursSystem = value;
  }

  add() {
    // ag-select は多重選択時、ドロップダウンを閉じる操作(outside click)があるまでconditions.gradCategoriesへ反映しない。
    // 追加ボタンのクリック自体もoutside click扱いになるが、そのイベントハンドラより先にこのadd()が呼ばれてしまうため、
    // 選択直後に追加ボタンを押すと選択内容が反映されない。close前に選択内容を確定させる。
    if (this.gradCategorySelect) {
      this.gradCategorySelect.confirm();
    }

    this.close(this.conditions);
  }

  private hasAmount(): boolean {
    return this.conditions.amount != null;
  }

  private hasFixedOvertimeConditions(): boolean {
    return this.hasAmount() && this.conditions.hours != null;
  }

  private hasOtherConditions(): boolean {
    return (
      this.conditions.monthlyScheduledWorkingHours != null ||
      this.conditions.annualScheduledWorkingHours != null ||
      this.conditions.variableWorkingHoursSystem != null
    );
  }
}
